export interface OficialMesaJSON {
  ofm_id: string | null;
  ofm_nombre: string;
  ofm_apellido: string;
  ofm_dni: string;
  ofm_email: string;
  ofm_estado: string;
  ofm_activo: boolean;
}

export class OficialMesa {
  protected constructor(
    private id: string | null,
    private nombre: string,
    private apellido: string,
    private dni: string,
    private email: string,
    private estado: string,
    private activo: boolean
  ) {}

  static createFrom(
    id: string | null,
    nombre: string,
    apellido: string,
    dni: string,
    email: string,
    estado: string,
    activo: boolean
  ) {
    return new this(id, nombre, apellido, dni, email, estado, activo);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: OficialMesa) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: OficialMesaJSON) {
    return OficialMesa.createFrom(
      entity.ofm_id,
      entity.ofm_nombre,
      entity.ofm_apellido,
      entity.ofm_dni,
      entity.ofm_email,
      entity.ofm_estado,
      entity.ofm_activo
    );
  }

  toJSON(): OficialMesaJSON {
    return {
      ofm_id: this.getId(),
      ofm_nombre: this.getNombre(),
      ofm_apellido: this.getApellido(),
      ofm_dni: this.getDni(),
      ofm_email: this.getEmail(),
      ofm_estado: this.getEstado(),
      ofm_activo: this.getActivo(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getNombre(): string {
    return this.nombre;
  }

  getApellido(): string {
    return this.apellido;
  }

  getDni(): string {
    return this.dni;
  }

  getEmail(): string {
    return this.email;
  }

  getEstado(): string {
    return this.estado;
  }

  getActivo(): any {
    return this.activo;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setNombre(value: string): void {
    this.nombre = value;
  }

  setApellido(value: string): void {
    this.apellido = value;
  }

  setDni(value: string): void {
    this.dni = value;
  }

  setEmail(value: string): void {
    this.email = value;
  }

  setEstado(value: string): void {
    this.estado = value;
  }

  setActivo(value: any): void {
    this.activo = value;
  }
}
